"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : DROPFILTER : DROPDOWN INDICATOR --------------- ++++++++++ */


var _default = {
  dropdownindicator: {
    width: '100%',
    height: '100%',
    background: _index.theme.color.light.light.swatch,
    borderRadius: (0, _index.pxToEm)(5),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxShadow: _index.theme.boxShadow.small,
    cursor: 'pointer',
    border: "".concat((0, _index.pxToEm)(2), " solid transparent"),
    transition: 'border .2s linear 0s',
    '&:hover': {
      borderColor: _index.theme.color.secondary.light.swatch
    },
    '&.active-true': {
      borderColor: _index.theme.color.primary.medium.swatch
    },
    '& .name-iconTitle': {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    '& .icon': {
      fontSize: (0, _index.pxToEm)(16),
      padding: "".concat((0, _index.pxToEm)(20), " ").concat((0, _index.pxToEm)(15)),
      color: _index.theme.color.neutral.medium.swatch
    },
    '& .name-nameTitle': {
      padding: "".concat((0, _index.pxToEm)(9), " 0"),
      '& .name': {
        fontSize: (0, _index.pxToEm)(14),
        height: (0, _index.pxToEm)(16),
        color: _index.theme.color.neutral.medium.swatch,
        fontWeight: 600
      },
      '& .title': {
        fontSize: (0, _index.pxToEm)(18),
        fontWeight: 500,
        color: _index.theme.color.supporting.dark.swatch
      },
      '& .selected': {
        color: _index.theme.color.primary.medium.swatch
      }
    },
    '& .name-sort-down': {
      padding: "0 ".concat((0, _index.pxToEm)(17)),
      color: _index.theme.color.supporting.dark.swatch
    }
  }
};
exports.default = _default;